export var AttachmentType = /*#__PURE__*/ function(AttachmentType) {
    AttachmentType["Folder"] = "FOLDER";
    AttachmentType["Task"] = "TASK";
    AttachmentType["StatusUpdate"] = "STATUS_UPDATE";
    AttachmentType["Conversation"] = "PROJECT_CONVERSATIONS";
    AttachmentType["SpaceTab"] = "SPACE_TAB";
    AttachmentType["Document"] = "DOCUMENT";
    AttachmentType["TaskConversation"] = "TASK_CONVERSATION";
    AttachmentType["SpaceTabConversation"] = "SPACE_TAB_CONVERSATION";
    AttachmentType["StatusUpdateConversation"] = "STATUS_UPDATE_CONVERSATION";
    AttachmentType["Expense"] = "EXPENSE";
    AttachmentType["Invoice"] = "INVOICE";
    AttachmentType["EmailMessage"] = "EMAIL_MESSAGE";
    return AttachmentType;
}({});
